import React from 'react';
import { THEMES } from '../../utils/constants';

export const InputGroup = ({ label, value, onChange, prefix = "", suffix = "", type = "number", step = "1", element='air' }) => {
    const theme = THEMES[element] || THEMES['air'];
    return (
        <div className="mb-4">
            <label className={`text-xs font-medium text-${theme.tailwind} uppercase tracking-wider mb-1 block`}>{label}</label>
            <div className="relative">
                {prefix && <span className="absolute left-3 top-2.5 text-slate-500 text-sm">{prefix}</span>}
                <input
                    type={type} step={step} value={value}
                    onChange={(e) => onChange(type === 'number' ? (parseFloat(e.target.value) || 0) : e.target.value)}
                    className={`w-full bg-slate-950 border border-slate-800 rounded-lg py-2 text-slate-100 focus:ring-1 focus:ring-${theme.tailwind} focus:border-${theme.tailwind} transition-all outline-none ${prefix ? 'pl-8' : 'pl-3'} ${suffix ? 'pr-8' : 'pr-3'}`}
                />
                {suffix && <span className="absolute right-3 top-2.5 text-slate-500 text-sm">{suffix}</span>}
            </div>
        </div>
    );
};